<template>
  <div>
    <div class="bg-white rounded-xl p-6 mb-6 w-full mt-4">
      <div class="flex items-center justify-between mb-4">
        <span class="font-semibold text-blue-700">All Assets</span>
        <input
          type="text"
          placeholder="Search Assets"
          class="rounded-lg border border-solid border-gray-200 px-3 py-2 text-sm focus:outline-none w-1/2"
          v-model="search"
        />
      </div>
      <div class="flex flex-col divide-y divide-gray-100">
        <div
          v-for="asset in searchedCurrency"
          :key="asset._id"
          class="flex items-center py-3 cursor-pointer"
          @click="openAsset(asset)"
        >
          <img
            :src="asset.logo"
            :alt="asset.currency"
            class="w-10 h-10 rounded-full mr-3"
          />
          <div class="flex-1">
            <div class="font-semibold text-gray-900">{{ asset.currency }}</div>
            <div class="text-xs text-gray-400">{{ asset.symbol }}</div>
          </div>
          <div class="text-right">
            <div class="font-semibold">
              {{ asset.price | formatPrice }}
            </div>
            <div
              :class="
                'text-xs ' +
                (asset.percentageChange >= 0
                  ? 'text-green-500'
                  : 'text-red-500')
              "
            >
              {{ asset.percentageChange }}%
            </div>
          </div>
        </div>
      </div>
      <div class="flex justify-between items-center mt-4">
        <RouterLink
          to="/user/products/crypto"
          class="text-base font-semibold flex items-center underline"
          >See all assets
          <v-icon small class="ml-1">mdi-chevron-right</v-icon></RouterLink
        >
      </div>
    </div>

    <ServiceUnavailableModal
      :value="showServiceUnavailable"
      action="trade"
      @input="showServiceUnavailable = $event"
    />
  </div>
</template>

<script>
import cryptoApi from '../../api/users/cryptocoin'
import ServiceUnavailableModal from '../ServiceUnavailableModal.vue'
import { isTradeRestricted } from '../../utils/tradeRestriction'

export default {
  name: 'CryptoListing',
  components: { ServiceUnavailableModal },
  data: () => ({
    currencies: [],
    loading: false,
    search: '',
    pollingInterval: null,
    showServiceUnavailable: false
  }),
  created() {
    this.getCryptosRate()
    this.pollingInterval = setInterval(() => {
      this.getCryptosRate()
    }, 30000)
  },
  beforeDestroy() {
    if (this.pollingInterval) {
      clearInterval(this.pollingInterval)
      this.pollingInterval = null
    }
  },
  computed: {
    searchedCurrency() {
      if (this.search) {
        return this.currencies.filter(
          (currency) =>
            currency.currency
              .toString()
              .toLowerCase()
              .includes(this.search.toLowerCase()) ||
            currency.symbol
              .toString()
              .toLowerCase()
              .includes(this.search.toLowerCase())
        )
      }
      return this.currencies
    }
  },
  methods: {
    openAsset(asset) {
      // TEMPORARY: auto-processed coins are naira trades - see
      // utils/tradeRestriction.js
      if (asset.hasAutoProcessing && isTradeRestricted(this.userCountry)) {
        this.showServiceUnavailable = true
        return
      }

      this.$router.push(
        asset.hasAutoProcessing
          ? `/user/products/crypto/auto-trade/${asset.coinId}`
          : `/user/products/crypto/trade/${asset.coinId}`
      )
    },
    async getCryptosRate() {
      this.loading = true
      const [ratesRes, walletsRes] = await Promise.all([
        cryptoApi.cryptoCoin().getCryptosRate(),
        cryptoApi.cryptoCoin().getCryptosWallets()
      ])
      const wallets = walletsRes.data.data || []
      this.currencies = (ratesRes.data.data || []).map((rate) => {
        const wallet = wallets.find((w) => w.coin._id === rate.coinId)
        return { ...rate, hasAutoProcessing: wallet?.coin?.hasAutoProcessing ?? false }
      })
      this.loading = false
    }
  },
  filters: {
    formatPrice(value) {
      return Number(value)
        .toFixed(5)
        .replace(/\.?0+$/, '')
    }
  }
}
</script>
